/* RESPONSIBLE TEAM: team-actions */
export const INSTALLATION_DOCS_URL = 'https://developers.intercom.com/installing-intercom/docs';
